import { XRayLibrary } from '~/features/x-ray/library';
import { useCurrentUser } from '~/hooks/useCurrentUser';
import { useTrackSegment } from '~/hooks/useTrackSegment ';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

const Page = () => {
  const { navigate, getSearchParam } = useRouting();
  const source = getSearchParam('source');
  const user = useCurrentUser();
  const trackSegment = useTrackSegment();

  trackSegment('Viewed Model Library', {
    userRole: user.role_uuid?.name ?? user.role,
  });

  const returnToSource = () => {
    if (source) {
      navigate(`${RoutePathType.AutomationHubFields}/${source}`);
    } else navigate(RoutePathType.AutomationHubFields);
  };

  return <XRayLibrary onCancel={returnToSource} />;
};

export default Page;
